// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import VueBarcode from "vue-barcode";


// import '@/mock/index.js'
import Print from '@/js/vue-print-nb/print';

import store from './store/store'

Vue.use(ElementUI);
Vue.use(Print); 


Vue.component('barcode', VueBarcode);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js